module.exports = __webpack_public_path__ + "img/77.5db65774.jpg";